import HookBuilderQuery from '@/hooks/HookBuilderQuery';
import { CommunityPhotosService } from '@/services/community-photos';

export const useCommunityPhotos = HookBuilderQuery.regularHook(
  ['community-photos'],
  CommunityPhotosService.search,
  {
    errorMessage: 'There was an error while fetching the community photos',
  },
);
